import React from "react";

const Header: React.FC = () => {
    return (
        <header>
            <div
                className="container-fluid"
                style={{ display: "flex", flexDirection: "column" }}
            >
                <img
                    style={{
                        width: "200px",
                        alignSelf: "center",
                        margin: "20px",
                    }}
                    className="img img-fluid"
                    src="assets/images/logo.png"
                    alt=""
                />
            </div>
        </header>
    );
};

export default Header;
